import { TextureLoader, RepeatWrapping, SRGBColorSpace } from 'three';

const textureLoader = new TextureLoader();
const loadedTextures = {};

function loadTextureAsync(url) {
  return new Promise((resolve, reject) => {
    textureLoader.load(url, resolve, undefined, reject);
  });
}

export async function loadAndApplyTextureToMaterial(material, texturePath, mapType = 'map') {
  const webpTexturePath = convertToWebP(texturePath);

  if (!loadedTextures[webpTexturePath]) {
    try {
      const texture = await loadTextureAsync(webpTexturePath);

      // Configure wrapping and flip
      texture.wrapS = RepeatWrapping;
      texture.wrapT = RepeatWrapping;
      texture.flipY = false;

      // Only color maps should use sRGB encoding
      if (mapType === 'map') {
        texture.colorSpace = SRGBColorSpace;
      }

      loadedTextures[webpTexturePath] = texture;
    } catch (error) {
      console.error(`Error loading texture ${webpTexturePath}:`, error);
      return;
    }
  }

  const previousMap = material[mapType];
  material[mapType] = loadedTextures[webpTexturePath];
  material.needsUpdate = true;

  // Dispose previous texture only if it's not the same
  if (previousMap && previousMap !== material[mapType]) {
    previousMap.dispose();
  }
}

function convertToWebP(texturePath) {
  return texturePath.replace(/\.(jpg|png)$/, '.webp');
}

export function disposeTexture() {
  for (const path in loadedTextures) {
    loadedTextures[path].dispose();
    delete loadedTextures[path];
  }
}

export { textureLoader };
